import React, { useCallback, ReactNode } from 'react';

import Image from 'next/image';

interface IconProps {
  src: string;
  alt: string;
  width: string | number;
  height: string | number | null;
  className?: string;
  onClick?: Function;
  id?: string;
  name?: string;
}

const Icon: React.FC<IconProps> = ({ src, alt, width, height, className, onClick = () => {}, id = '', name = '' }) => {
  const handleIconClick = useCallback(() => {
    onClick(name, id);
  }, [id, name, onClick]);

  return (
    <Image
      id={id}
      src={src}
      className={className}
      width={+width}
      height={height ? +height : 24}
      alt={alt}
      onClick={handleIconClick}
      aria-hidden="true"
    />
  );
};

interface IconNewProps {
  id?: string;
  glyph: string;
  children: ReactNode;
  ariaLabel: string;
  className?: string;
  ariaHidden?: boolean;
  svgId?: string;
  width: number;
  height: number;
  xmlns?: string;
  version?: string;
  onClick?: () => void;
  dataName?: string;
}

export const IconNew: React.FC<IconNewProps> = ({
  id,
  glyph,
  children,
  ariaLabel,
  className = '',
  ariaHidden = false,
  svgId,
  width,
  height,
  xmlns = '',
  version = '',
  onClick = () => {},
  dataName = '',
}) => (
  <span id={id} className={`Icon ${glyph}`} style={{ height, width, display: 'inline-flex' }} aria-label={ariaLabel}>
    <svg
      id={svgId}
      viewBox={`0 0 ${width} ${height}`}
      className={className}
      aria-hidden={ariaHidden}
      data-name={dataName}
      xmlns={xmlns}
      version={version}
      onClick={onClick}
    >
      {children}
    </svg>
  </span>
);

export default Icon;
